import React, { memo } from "react";
import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";

const DetailIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      sx={{ fontSize: "inherit", ...sx }}
      {...otherProps}
    >
      <path
        d="M16 8.13426V7.16204C16 7.07292 15.928 7 15.84 7H6.16C6.072 7 6 7.07292 6 7.16204V8.13426C6 8.22338 6.072 8.2963 6.16 8.2963H15.84C15.928 8.2963 16 8.22338 16 8.13426ZM6.16 9.91667C6.072 9.91667 6 9.98958 6 10.0787V11.0509C6 11.14 6.072 11.213 6.16 11.213H11.5C11.588 11.213 11.66 11.14 11.66 11.0509V10.0787C11.66 9.98958 11.588 9.91667 11.5 9.91667H6.16Z"
        fill="currentColor"
      />
      <path
        d="M6 12.8657C6 12.7766 6.072 12.7037 6.16 12.7037H9.5C9.588 12.7037 9.66 12.7766 9.66 12.8657V13.838C9.66 13.9271 9.588 14 9.5 14H6.16C6.072 14 6 13.9271 6 13.838V12.8657Z"
        fill="currentColor"
      />
      <path
        d="M9.57692 16.5484H4.55769V5.45161H17.4423V11.8387C17.4423 11.9274 17.5202 12 17.6154 12H18.8269C18.9221 12 19 11.9274 19 11.8387V4.64516C19 4.28831 18.6906 4 18.3077 4H3.69231C3.30937 4 3 4.28831 3 4.64516V17.3548C3 17.7117 3.30937 18 3.69231 18H9.57692C9.67212 18 9.75 17.9274 9.75 17.8387V16.7097C9.75 16.621 9.67212 16.5484 9.57692 16.5484Z"
        fill="currentColor"
      />
      <path
        d="M18.9549 19.1524L17.1433 17.3752C17.5763 16.8133 17.8345 16.1124 17.8345 15.3524C17.8345 13.501 16.3045 12 14.4173 12C12.53 12 11 13.501 11 15.3524C11 17.2038 12.53 18.7048 14.4173 18.7048C15.1124 18.7048 15.757 18.501 16.2968 18.1524L18.1355 19.9562C18.1666 19.9867 18.2054 20 18.2442 20C18.2831 20 18.3238 19.9848 18.353 19.9562L18.9549 19.3657C19.015 19.3067 19.015 19.2114 18.9549 19.1524ZM14.4173 17.4857C13.2154 17.4857 12.2426 16.5314 12.2426 15.3524C12.2426 14.1733 13.2154 13.219 14.4173 13.219C15.6191 13.219 16.5919 14.1733 16.5919 15.3524C16.5919 16.5314 15.6191 17.4857 14.4173 17.4857Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default memo(DetailIcon);
